var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.204,
    height: 10.203,
    viewBox: "0 0 10.204 10.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1356.868,441.21a.321.321,0,0,1,.117.247v8.928a.319.319,0,0,1-.256.313l-3.189.638h-.125l-3.126-.625-3.126.625a.319.319,0,0,1-.375-.25.27.27,0,0,1-.007-.063V442.1a.32.32,0,0,1,.257-.313l3.188-.637h.125l3.127.625,3.126-.625A.318.318,0,0,1,1356.868,441.21Zm-3.709,1.146-2.551-.51v8.278l2.551.51Zm.638,8.278,2.55-.51v-8.278l-2.55.51Zm-3.827-.51v-8.278l-2.551.51v8.278Z",
    transform: "translate(-1346.781 -441.139)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.34a349eb303af785a22333989b778544.svg";
export { ForwardRef as ReactComponent };